<template>
  <div class="tipslista__container">
    <div class="tipslista__header" aria-hidden="true">
      <span class="tipslista__cell tipslista__cell--status">Status</span>
      <span class="tipslista__cell tipslista__cell--rubrik">Rubrik</span>
      <span class="tipslista__cell tipslista__cell--tipsare">Tipsare</span>
      <span class="tipslista__cell tipslista__cell--inkommet">Inkommet</span>
      <span class="tipslista__cell tipslista__cell--publicerat">Publicerat</span>
      <span class="tipslista__cell tipslista__cell--knapp"></span>
    </div>

    <ul class="tipslista">
      <li v-for="tips in items" :key="tips.Id || tips.FormSubmissonId" class="tipslista__post">
        <div class="tipslista__cell tipslista__cell--status">
          <div class="tipslista__cell--mobile-header">Status</div>
          <span :class="tips.Status">{{ statusLabel(tips.Status) }}</span>
        </div>

        <div class="tipslista__cell tipslista__cell--rubrik">
          <div class="tipslista__cell--mobile-header">Rubrik</div>
          <span>{{ tips.Rubrik }}</span>
        </div>

        <div class="tipslista__cell tipslista__cell--tipsare">
          <div class="tipslista__cell--mobile-header">Tipsare</div>
          <span>{{ tips.InskickadAvNamn }}</span>
        </div>

        <div class="tipslista__cell tipslista__cell--inkommet">
          <div class="tipslista__cell--mobile-header">Inkommet</div>
          <span>{{ tips.InskickadDatumTid }}</span>
        </div>

        <div class="tipslista__cell tipslista__cell--publicerat">
          <div class="tipslista__cell--mobile-header">Publicerat</div>
          <span v-if="tips.PubliceradDatumTid">{{ tips.PubliceradDatumTid }}</span>
          <span v-else>Ej publicerad</span>
        </div>

        <div class="tipslista__cell tipslista__cell--knapp">
          <button
            class="btn btn-default"
            type="button"
            :aria-label="`Öppna tipset ${tips.Rubrik}`"
            @click="$emit('open-preview', tips)"
          >Öppna</button>
        </div>
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { HanteraTipsItemDto } from './hanteraTipsSidaService';

const statusLabels: Record<string, string> = {
  Nyinkommet:   'Nyinkommet',
  Granskas:     'Granskas',
  Publicerat:   'Publicerat',
  Kompletteras: 'Kompletteras',
  Avpublicerat: 'Avpublicerat',
  UtgårSnart:   'Utgår snart',
};

export default defineComponent({
  name: 'HanteraTipsList',
  props: {
    items: { type: Array as PropType<HanteraTipsItemDto[]>, required: true },
  },
  emits: ['open-preview'],
  setup() {
    function statusLabel(status: string): string {
      return statusLabels[status] ?? status;
    }
    return { statusLabel };
  },
});
</script>
